<template>
    <div class="fabrication-page">
        <h1 v-if="lang == 'fr'">L'atelier de fabrication</h1>
        <h1 v-if="lang == 'en'">The fabrication shop</h1>
        <flickity-box cls="flickity" ref="flickity" :options="flickityOptions">
            <template>
                <img src="../assets/fabrication_1.jpg" />
                <img src="../assets/fabrication_2.jpg" />
                <img src="../assets/fabrication_3.jpg" />
                <img src="../assets/fabrication_4.jpg" />
                <img src="../assets/fabrication_5.jpg" />
            </template>
        </flickity-box>

        <router-link v-if="lang == 'fr'" to="/savoir-faire">Revenir au savoir-faire</router-link>
        <router-link v-if="lang == 'en'" to="/know-how">Back to know-how</router-link>
    </div>

</template>

<script>
  import FlickityBox from './FlickityBox';

  export default {

    components: {
      FlickityBox,
    },
    props: ['lang'],
    data() {
      return {
        flickityOptions: {
          wrapAround: true,
          pageDots: false,
          prevNextButtons: true,
          selectedAttraction: 0.3,
          friction: 1,
        },
      };
    },
  };
</script>
<style lang="scss">
    .fabrication-page {
        .flickity-viewport {
            margin-left: 25px;
            margin-right: 25px;
            margin-bottom: 25px;
        }

        .flickity-prev-next-button.previous {
            left: -10px;
        }
        .flickity-prev-next-button.next {
            right: -10px;
        }

        .flickity-prev-next-button {
            width: 30px;
            height: 30px;
        }

        .carousel-cell {
            display: flex;
            align-items: stretch;
            @media screen and (max-width:768px){
                flex-direction: column;
            }

        }
        .carousel-cell > div{
            flex: 1;
        }


        img {
            visibility: hidden;
            &.is-selected {
                visibility: visible;
            }
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/FabricationPage.vue